import { StyledFlex, StyledMargin, UncontrolledCheckbox } from '@dreryk/react-components';

import { useResourceBranchByHealthcareProviderType } from '~libs.shared.account';

import { prescriptionsTranslationKeys } from '../../../translations';

import { PrescriptionHistoryPanelFilters } from './PatientPrescriptionHistoryPanelFilters.types';

type PatientPrescriptionHistoryPanelFiltersProps = {
   readonly filters: PrescriptionHistoryPanelFilters;
   readonly onIssuedByCurrentPractitionerChange: (value: boolean) => void;
   readonly onContinuouslyUsedMedicineChange: (value: boolean) => void;
};

export const PatientPrescriptionHistoryPanelFilters = (
   props: PatientPrescriptionHistoryPanelFiltersProps
): JSX.Element => {
   const shouldShowOnlyMineFilter = useResourceBranchByHealthcareProviderType(true, false);

   return (
      <StyledMargin bottom={8} top={1}>
         <StyledFlex gap={'16px'}>
            {shouldShowOnlyMineFilter ? (
               <UncontrolledCheckbox
                  testId={'issuedByCurrentPractitioner'}
                  name={'issuedByCurrentPractitioner'}
                  id={'issuedByCurrentPractitioner'}
                  label={prescriptionsTranslationKeys.prescriptionHistoryPanel.filters.onlyMine}
                  selected={props.filters.issuedByCurrentPractitioner}
                  onSelectionChange={props.onIssuedByCurrentPractitionerChange}
               />
            ) : null}
            <UncontrolledCheckbox
               testId={'continuouslyUsedMedicine'}
               name={'continuouslyUsedMedicine'}
               id={'continuouslyUsedMedicine'}
               label={prescriptionsTranslationKeys.prescriptionHistoryPanel.filters.onlyContinuouslyUsed}
               selected={props.filters.continuouslyUsedMedicine}
               onSelectionChange={props.onContinuouslyUsedMedicineChange}
            />
         </StyledFlex>
      </StyledMargin>
   );
};
